import { Route, Routes } from 'react-router';
import { SOCIAL_SHARE_DRAFT_TEMPLATES, type SocialShareDraftTemplate } from '@constants';

export const SOCIAL_PATH_PREFIX = '/social/';

/**
 * Social graphics render on their own, without the site header, footer and ads. The server keeps the same rule
 * (`lib/socialGraphicHtml.mjs`) to leave every tag on a host the capture blocks out of these pages' HTML.
 */
export const isSocialGraphicPath = (pathname: string) => pathname.startsWith(SOCIAL_PATH_PREFIX);

type SocialRoutesProps = {
  fixtures: React.ReactNode;
  table: React.ReactNode;
  /** The page for a poster drawn from a stored draft: Quote, Cup Draw, Announcement or Club Results. */
  draft: (template: SocialShareDraftTemplate) => React.ReactNode;
};

/**
 * The page elements are passed in so the client can lazy-load them while SSR imports them
 * statically (renderToString can't wait on a lazy chunk).
 */
export function SocialRoutes({ fixtures, table, draft }: SocialRoutesProps) {
  return (
    <Routes>
      <Route path="/social/fixtures" element={fixtures} />
      <Route path="/social/table" element={table} />
      {SOCIAL_SHARE_DRAFT_TEMPLATES.map((template) => (
        <Route key={template} path={`${SOCIAL_PATH_PREFIX}${template}`} element={draft(template)} />
      ))}
    </Routes>
  );
}
